module.exports = __webpack_public_path__ + "img/banner_xhjh.ade184f6.png";